import React, { createContext, useState, ReactNode } from 'react';

interface MyAccountContextProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MyAccountContext = createContext<MyAccountContextProps>({
	isOpen: false,
	setIsOpen: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function MyAccountProvider({ children }: ContextProps) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<MyAccountContext.Provider value={{ isOpen, setIsOpen }}>
			{children}
		</MyAccountContext.Provider>
	);
}

export default MyAccountContext;
